import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import { Badge, Row, Col } from "reactstrap";
import DropdownView from "../Exam/UploadRapor/DropdownView";
import CustomModal from "../../components/CustomModal";
import { setList } from "../../functions/functionGeneral";

class FormSetting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      setting_id: "",
      setting_user_id: "",
      setting_user_value: "",
      isButtonLoading: false,
      isLoading: false,
      dataSetting: [],
      dataSettingList: [],
      isModalShow: false,
      setVal: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleModal = this.toggleModal.bind(this);
    this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this);
  }

  toggleModal() {
    this.setState({ isModalShow: !this.state.isModalShow });
  }

  handleSubmitDeleteButton() {
    axios({
      method: "get",
      url: "/mysetting/delete/" + this.state.setting_user_id,
    })
      .then((response) => {
        const result = response.data;
        Alert.success(result.text);
        this.loadData();
        this.toggleModal();

        return;
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!");
      });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  loadData() {
    this.setState({ isLoading: true });

    axios({
      method: "post",
      url: "/mysetting?user_id=" + this.props.match.params.user_id,
    })
      .then((response) => {
        const result = response.data;
        if (result.status) {
          this.setState({
            dataSetting: result.data,
          });
        } else {
          Alert.error(result.text);
        }

        this.setState({ isLoading: false });
      })
      .catch((error) => {
        console.log(error);
        Alert.error("Gagal terhubung ke server!");
        this.setState({ isLoading: false });
      });
  }

  loadDataSetList() {
    this.setState({ isLoading: true });

    axios({
      method: "post",
      url: "/setting",
    })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          const dataSettingList = result.data.map((item) => ({
            key: item.setting_id,
            value:
              item.setting_name.toUpperCase() +
              " - *(Format: " +
              item.setting_value +
              ")",
          }));

          this.setState({
            dataSettingList,
            isLoading: false,
          });
        } else {
          Alert.error(result.text);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ isLoading: false });
        Alert.error("Gagal terhubung ke server!");
      });
  }

  handleSubmit() {
    this.setState({ isButtonLoading: true });

    let formData = new FormData();
    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    formData.append("user_id", this.props.match.params.user_id);
    formData.append("setVal", this.state.setVal);
    formData.append("setting_user_value", this.state.setting_user_value);
    const url = "/mysetting/add";

    axios
      .post(url, formData, config)
      .then((response) => {
        const result = response.data;
        if (result.status) {
          Alert.success(result.text);
          this.setState(
            {
              setting_id: "",
              setting_user_value: "",
              isButtonLoading: false,
            },
            () => {
              this.loadData();
            }
          );
        } else {
          if (Array.isArray(result.text)) {
            result.message.map((item) => {
              Alert.error(item);
              return true;
            });
          } else {
            Alert.error(result.text);
          }
          this.setState({ isButtonLoading: false });
        }
      })
      .catch((error) => {
        console.log("ERROR", error);
        Alert.error("Gagal terhubung ke server!");
        this.setState({ isButtonLoading: false });
      });
  }

  componentDidMount() {
    this.loadData();
    this.loadDataSetList();
  }

  render() {
    return (
      <div className="col-sm-12">
        <CustomModal
          isShow={this.state.isModalShow}
          toggleModal={this.toggleModal}
          handleSubmit={this.handleSubmitDeleteButton}
          modalHeaderText="Hapus Data"
          modalBodyText="Anda yakin ingin menghapus data ini?"
          modalSubmitText="Ya"
        />
        <Row>
          <Col>
            <div className="card">
              <div className="card-header">List Pengaturan</div>
              <div className="card-block">
                {this.state.isLoading ? (
                  "Memuat Data..."
                ) : this.state.dataSetting.length === 0 ? (
                  "Data Kosong..."
                ) : (
                  <div>
                    <table className="table table-striped animated fadeIn">
                      <thead>
                        <tr>
                          <th width={10}>No</th>
                          <th>Seeting</th>
                          <th>Value</th>
                          <th width={100}>Opsi</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.dataSetting.map((item, i) => {
                          return (
                            <tr key={item.setting_user_id}>
                              <td>{i + 1}</td>
                              <td>
                                {item.settingName.setting_name.toUpperCase()}
                              </td>
                              <td>{item.setting_user_value}</td>
                              <td>
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => {
                                    this.toggleModal();
                                    this.setState({
                                      setting_user_id: item.setting_user_id,
                                    });
                                  }}
                                >
                                  <i className="fa fa-trash-o"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </Col>
          <Col>
            <div className="card">
              <div className="card-header">Tambah Pengaturan</div>
              <div className="card-block">
                <div className="col-md-12">
                  <DropdownView
                    handleChange={this.handleChange}
                    stateName="setVal"
                    label="Pilih Pengaturan"
                    items={setList}
                    value={this.state.setVal}
                  />
                </div>
                <div className="col-md-12">
                  <input
                    name="setting_user_value"
                    type="text"
                    className="form-control"
                    placeholder=""
                    value={this.state.setting_user_value}
                    onChange={this.handleChange}
                  />
                </div>
              </div>
              <div className="card-footer">
                <button
                  type="button"
                  className="btn btn-md btn-primary"
                  disabled={this.state.isButtonLoading && "disabled"}
                  onClick={this.handleSubmit}
                >
                  {this.state.isButtonLoading ? "Loading" : "Simpan"}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default FormSetting;



// WEBPACK FOOTER //
// ./src/views/Users/FormSetting.js